import React from 'react';
import { Tooltip, Zoom } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import useTypedSelector from 'hooks/useTypedSelector';
import { StyledFab } from './styles';

const WhatsAppPopup: React.FC = () => {
  const { item } = useTypedSelector((state) => state.contactSettings);
  const whatsappNumber = item?.whatsappNumber || '';

  if (!whatsappNumber) return null;

  const cleanNumber = whatsappNumber.replace(/\D/g, '');
  const url = `https://wa.me/${cleanNumber}`;

  return (
    <Zoom in={!!whatsappNumber} timeout={500}>
      <Tooltip title="¿Consultas? Escríbenos por WhatsApp" placement="left">
        <StyledFab
          color="success"
          aria-label="whatsapp-contact"
          onClick={() => window.open(url, '_blank')}
        >
          <WhatsAppIcon />
        </StyledFab>
      </Tooltip>
    </Zoom>
  );
};

export default WhatsAppPopup;
